import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- Make sure this import is here
import {
  DocumentTextIcon,
  ChatBubbleLeftRightIcon,
  ArrowPathIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';
import styles from '../components/enquiries/Enquiries.module.css';
const pdfUrl = '/boutee-overview.pdf';
const ShareBoutee = () => {
  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedMessage, setCopiedMessage] = useState(false);
  const navigate = useNavigate();

  const shareLink = "https://shorturl.at/msn2C";
  
  const shareMessage = `Hi! I wanted to share some information about Boutee with you.

I've been using their platform and thought you might find it interesting. Boutee helps jewellers connect with customers looking for bespoke engagement rings.

Here's an overview that explains how it works: ${shareLink}

Let me know if you have any questions!`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };

  const handleCopyMessage = () => {
    navigator.clipboard.writeText(shareMessage);
    setCopiedMessage(true);
    setTimeout(() => setCopiedMessage(false), 2000);
  };

  const handleDownloadPDF = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Boutee-Overview.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const baseActionButton = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--spacing-xs)',
    padding: 'var(--spacing-s) var(--spacing-l)',
    fontSize: 'var(--font-size-button)',
    fontWeight: 'var(--button-font-weight)',
    fontFamily: 'var(--font-family-primary)',
    borderRadius: 'var(--button-radius)',
    border: '1px solid var(--Stroke-Light)',
    cursor: 'pointer',
    transition: 'var(--transition-all)',
    boxShadow: 'var(--shadow-sm)',
    background: 'var(--Surface-Secondary)',
    color: 'var(--Text-Primary)'
 };

  return (
    <div className={styles.container}>
      {/* Header matching Enquiries design */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerText}>
            <h1 className={styles.headerTitle}>Share Boutee with another jeweller</h1>
            <p className={styles.headerSubtitle}>
              When another jeweller asks if Boutee is worth joining, you can share this overview with them. 
              It provides a clear explanation of how the platform works and what benefits it offers.
            </p>
          </div>
        </div>
      </div>

      {/* Action Cards Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 'var(--spacing-m)',
        marginBottom: 'var(--spacing-l)'
      }}>
        {/* Card 1: Overview Document */}
        <button
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--spacing-m)',
            padding: 'var(--spacing-l)',
            background: 'var(--Surface-Primary)',
            border: '2px solid var(--Stroke-Light)',
            borderRadius: 'var(--radius-xl)',
            cursor: 'default',
            transition: 'var(--transition-all)',
            textAlign: 'left',
            boxShadow: 'var(--shadow-sm)'
          }}
        >
          <DocumentTextIcon style={{ width: '2.5rem', height: '2.5rem', color: 'var(--Purple-600)', flexShrink: 0 }} />
          <div>
            <div style={{ 
              fontSize: 'var(--font-size-body2)', 
              fontWeight: 'var(--font-weight-semibold)', 
              color: 'var(--Text-Primary)', 
              marginBottom: 'var(--spacing-xxs)' 
            }}>
              Boutee - Overview for jewellers
            </div>
            <div style={{ 
              fontSize: 'var(--font-size-body4)', 
              color: 'var(--Text-Secondary)',
              marginBottom: 'var(--spacing-m)'
            }}>
              This is the main overview most jewellers share. It includes how Boutee works, requirements and what makes the platform valuable.
            </div>
            <div style={{ display: 'flex', gap: 'var(--spacing-s)', flexWrap: 'wrap' }}>
              <button
                onClick={handleCopyLink}
                style={{
                    ...baseActionButton,
                    background: copiedLink ? 'var(--Green-50)' : 'var(--Surface-Secondary)',
                    color: copiedLink ? 'var(--Green-800)' : 'var(--Text-Primary)',
                    borderColor: copiedLink ? 'var(--Green-200)' : 'var(--Stroke-Light)'
                }}
                onMouseEnter={(e) => {
                    if (!copiedLink) {
                    e.currentTarget.style.background = 'var(--Purple-50)';
                    e.currentTarget.style.borderColor = 'var(--Purple-200)';
                    e.currentTarget.style.color = 'var(--Purple-700)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!copiedLink) {
                    e.currentTarget.style.background = 'var(--Surface-Secondary)';
                    e.currentTarget.style.borderColor = 'var(--Stroke-Light)';
                    e.currentTarget.style.color = 'var(--Text-Primary)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                    }
                }}
                >
                {copiedLink && <CheckCircleIcon style={{ width: '1rem', height: '1rem' }} />}
                {copiedLink ? 'Copied!' : 'Copy share link'}
              </button>
              <button
                onClick={handleDownloadPDF}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 'var(--spacing-xs)',
                  padding: 'var(--spacing-xs) var(--spacing-m)',
                  fontSize: 'var(--font-size-button)',
                  fontWeight: 'var(--button-font-weight)',
                  fontFamily: 'var(--font-family-primary)',
                  borderRadius: 'var(--button-radius)',
                  cursor: 'pointer',
                  transition: 'var(--transition-all)',
                  boxShadow: 'var(--shadow-sm)',
                  background: 'var(--Button-Secondary-Enabled-BG)',
                  color: 'var(--Button-Secondary-Text)',
                  border: 'none'
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--Button-Secondary-Hovered-BG)', e.currentTarget.style.transform = 'translateY(-1px)', e.currentTarget.style.boxShadow = 'var(--shadow-md)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--Button-Secondary-Enabled-BG)', e.currentTarget.style.transform = 'translateY(0)', e.currentTarget.style.boxShadow = 'var(--shadow-sm)')}
              >
                Download PDF
              </button>
            </div>
          </div>
        </button>

        {/* Card 2: Quick Message */}
        <button
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--spacing-m)',
            padding: 'var(--spacing-l)',
            background: 'var(--Surface-Primary)',
            border: '2px solid var(--Stroke-Light)',
            borderRadius: 'var(--radius-xl)',
            cursor: 'default',
            transition: 'var(--transition-all)',
            textAlign: 'left',
            boxShadow: 'var(--shadow-sm)'
          }}
        >
          <ChatBubbleLeftRightIcon style={{ width: '2.5rem', height: '2.5rem', color: 'var(--Blue-600)', flexShrink: 0 }} />
          <div>
            <div style={{ 
              fontSize: 'var(--font-size-body2)', 
              fontWeight: 'var(--font-weight-semibold)', 
              color: 'var(--Text-Primary)', 
              marginBottom: 'var(--spacing-xxs)' 
            }}>
              Send a quick message
            </div>
            <div style={{ 
              fontSize: 'var(--font-size-body4)', 
              color: 'var(--Text-Secondary)',
              marginBottom: 'var(--spacing-m)'
            }}>
              Pre-written message you can copy and send via email, WhatsApp, or text. It includes a friendly introduction and the share link.
            </div>
            <button
              onClick={handleCopyMessage}
                style={{
                    ...baseActionButton,
                    background: copiedMessage ? 'var(--Green-50)' : 'var(--Surface-Secondary)',
                    color: copiedMessage ? 'var(--Green-800)' : 'var(--Text-Primary)',
                    borderColor: copiedMessage ? 'var(--Green-200)' : 'var(--Stroke-Light)'
                }}
                onMouseEnter={(e) => {
                    if (!copiedMessage) {
                    e.currentTarget.style.background = 'var(--Purple-50)';
                    e.currentTarget.style.borderColor = 'var(--Purple-200)';
                    e.currentTarget.style.color = 'var(--Purple-700)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!copiedMessage) {
                    e.currentTarget.style.background = 'var(--Surface-Secondary)';
                    e.currentTarget.style.borderColor = 'var(--Stroke-Light)';
                    e.currentTarget.style.color = 'var(--Text-Primary)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                    }
                }}
                >
                {copiedMessage && <CheckCircleIcon style={{ width: '1rem', height: '1rem' }} />}
                {copiedMessage ? 'Copied!' : 'Copy message'}
            </button>
          </div>
        </button>

        {/* Card 3: What Happens Next */}
        <button
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--spacing-m)',
            padding: 'var(--spacing-l)',
            background: 'var(--Surface-Primary)',
            border: '2px solid var(--Stroke-Light)',
            borderRadius: 'var(--radius-xl)',
            cursor: 'default',
            transition: 'var(--transition-all)',
            textAlign: 'left',
            boxShadow: 'var(--shadow-sm)'
          }}
        >
          <ArrowPathIcon style={{ width: '2.5rem', height: '2.5rem', color: 'var(--Green-600)', flexShrink: 0 }} />
          <div>
            <div style={{ 
              fontSize: 'var(--font-size-body2)', 
              fontWeight: 'var(--font-weight-semibold)', 
              color: 'var(--Text-Primary)', 
              marginBottom: 'var(--spacing-xxs)' 
            }}>
              What happens if they're interested?
            </div>
            <div style={{ 
              fontSize: 'var(--font-size-body4)', 
              color: 'var(--Text-Secondary)'
            }}>
              If they want to learn more, they can reach out to the Boutee team directly. You don't need to do anything else. Thank you for sharing us!
            </div>
          </div>
        </button>
      </div>

      {/* Referral Incentive Box */}
        {<div style={{
        backgroundColor: 'var(--Blue-50)',
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--spacing-xl)',
        border: '1px solid var(--Blue-200)',
        marginBottom: 'var(--spacing-l)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--spacing-l)',
        flexWrap: 'wrap'
        }}>
        <div>
            <h3 style={{
            fontSize: 'var(--font-size-subtitle1)',
            fontWeight: 'var(--font-weight-subtitle1)',
            color: 'var(--Text-Primary)',
            marginBottom: 'var(--spacing-xs)'
            }}>
            Invite a jeweller
            </h3>
            <p style={{
            fontSize: 'var(--font-size-body3)',
            color: 'var(--Text-Secondary)',
            margin: 0,
            lineHeight: '1.6'
            }}>
            £50 for you, 20% off for them
            </p>
        </div>
        <button
            onClick={() => navigate('/refer-jeweller')}
            className={styles.newEnquiryButton}
            >
            <svg className={styles.buttonIcon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            See more details
        </button>
        </div>}

      {/* Supporting Content Section */}
      <div style={{
        background: 'var(--Surface-Primary)',
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--spacing-xl)',
        boxShadow: 'var(--shadow-card)',
        border: 'var(--card-border)',
        marginBottom: 'var(--spacing-l)'
      }}>
        <h3 style={{
          fontSize: 'var(--font-size-subtitle2)',
          fontWeight: 'var(--font-weight-subtitle2)',
          color: 'var(--Text-Primary)',
          margin: '0 0 var(--spacing-l) 0',
          paddingBottom: 'var(--spacing-m)',
          borderBottom: '2px solid var(--Stroke-Light)'
        }}>
          What you're sharing
        </h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          gap: 'var(--spacing-l)',
          alignItems: 'start'
        }}>
          {/* Thumbnail */}
          <img 
          src="/overview-thumbnail.png"
          alt="Boutee Overview Document"
          style={{
                width: '180px',
                height: '120px',
                borderRadius: 'var(--radius-s)',
                border: '1px solid var(--Stroke-Light)',
                objectFit: 'cover',
                flexShrink: 0
            }}
          />
 
          {/* Bullet Points */}
          <div>
            <ul style={{
              listStyleType: 'disc',
              paddingLeft: 'var(--spacing-l)',
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--spacing-s)',
              margin: 0
            }}>
              <li style={{
                fontSize: 'var(--font-size-body3)',
                lineHeight: 'var(--line-height-body3)',
                color: 'var(--Text-Secondary)'
              }}>
                How Boutee connects jewellers with customers looking for bespoke engagement pieces
              </li>
              <li style={{
                fontSize: 'var(--font-size-body3)',
                lineHeight: 'var(--line-height-body3)',
                color: 'var(--Text-Secondary)'
              }}>
                The platform's pricing structure and commission model
              </li>
              <li style={{
                fontSize: 'var(--font-size-body3)',
                lineHeight: 'var(--line-height-body3)',
                color: 'var(--Text-Secondary)'
              }}>
                What types of jewellers benefit most from the platform
              </li>
              <li style={{
                fontSize: 'var(--font-size-body3)',
                lineHeight: 'var(--line-height-body3)',
                color: 'var(--Text-Secondary)'
              }}>
                Success stories and testimonials from other jewellers
              </li>
              <li style={{
                fontSize: 'var(--font-size-body3)',
                lineHeight: 'var(--line-height-body3)',
                color: 'var(--Text-Secondary)'
              }}>
                How to get started and what the onboarding process looks like
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Reassurance Text */}
      <div style={{
        background: 'var(--Grey-50)',
        border: '1px solid var(--Stroke-Light)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--spacing-l)',
        textAlign: 'center'
      }}>
        <p style={{
          fontSize: 'var(--font-size-body4)',
          color: 'var(--Text-Tertiary)',
          margin: 0,
          maxWidth: '700px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          You're simply sharing information about Boutee - not selling or endorsing. 
          Feel free to share your own experience if asked, but there's no pressure to 
          promote the platform beyond providing the overview.
        </p>
      </div>
    </div>
  );
};

export default ShareBoutee;


